import React, { useState, useRef } from "react";
import classes from "../Store.module.scss";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";

interface Props {
  pixInfo: any;
  isLoadingPix: boolean;
}

const PixPaymentCard: React.FC<Props> = ({ pixInfo, isLoadingPix }) => {
  const { t } = useTranslation();
  const QrCode = pixInfo?.qrcode;
  const EmvCode = pixInfo?.emv;

  const pixRef = useRef<HTMLDivElement | null>(null);
  const [copiedPix, setCopiedPix] = useState(false);

  const copyCodePix = async () => {
    try {
      if (pixRef.current) {
        await navigator.clipboard.writeText(pixRef.current.innerText);
        setCopiedPix(true);
        setTimeout(() => {
          setCopiedPix(false);
        }, 2000);
      }
    } catch (error) {
      console.log("Erro ao copiar");
    }
  };

  return (
    <div className={classes.PixCard}>
      <h2>{t("purchase.pix_payment")}</h2>
      <div className={classes.PixInfo}>
        {isLoadingPix ? (
          <Spinner />
        ) : (
          <img src={QrCode} className={classes.PixInfoQrcode} alt="QRCode" />
        )}
        <div className={classes.PixQRCodeInfo}>
          <h4>{t("purchase.how_to_pay_with_qr_code")}</h4>
          <p>
            <span>1 </span>
            {t("purchase.pix_info_1")}
          </p>
          <p>
            <span>2 </span>
            {t("purchase.pix_info_2")}
          </p>
        </div>
      </div>
      <p className={classes.PixPaymentHelpText}>
        {t("purchase.pix_payment_help")}
      </p>
      <div className={classes.PixInfo}>
        {isLoadingPix ? (
          <Spinner />
        ) : (
          <div className={classes.PixCopyPasteArea}>
            {/* Botão de copiar pix */}
            <div className={classes.PixCopyButton}>
              <div ref={pixRef} className={classes.PixCode}>
                <p>{EmvCode}</p>
              </div>
              <button onClick={copyCodePix}>
                {copiedPix ? "Copiado" : "Copiar"}
              </button>
            </div>
            <div className={classes.PixCopyPasteAreaInfo}>
              <div>
                <FontAwesomeIcon icon={faCircleExclamation} color={"#007085"} />
              </div>
              <div className={classes.PixCopyPasteAreaInfoText}>
                <p>{t("purchase.pix_payment_deadline")}</p>
                <p>{t("purchase.pix_payment_processing")}</p>
              </div>
            </div>
          </div>
        )}
        <div>
          <div className={classes.PixQRCodeInfo}>
            <h4>{t("purchase.how_to_pay_with_pix_copy_paste")}</h4>
            <div>
              <span>1 </span>
              {t("purchase.copy_paste_pix_info_1")}
            </div>
            <div>
              <span>2 </span>
              {t("purchase.copy_paste_pix_info_2")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PixPaymentCard;
